module.exports = __webpack_public_path__ + "static/saliva-sample-c7b92c9e3b8c0d982154b3bfa4e1929a.png";